import {
  EntityList,
  EntityListProps,
  renderDate,
  renderInvertedYesNoIcon,
} from 'components/EntityList'
import { News } from 'gql.generated'
import {
  ConstrainMode,
  DetailsRow,
  IDetailsRowStyles,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'
import { createFieldColumn } from 'views/helpers'

export type NewsListProps = EntityListProps<News> & {
  styledElementsCount: number
}

export const NewsList: React.FunctionComponent<NewsListProps> = ({
  items,
  styledElementsCount,
  ...props
}) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const theme = useTheme()
  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        minWidth: 100,
        ungroupable: true,
      }),
      fieldColumn('title', {
        minWidth: 100,
        ungroupable: true,
      }),
      fieldColumn('provingGround', {
        minWidth: 100,
        ungroupable: true,
        onRender: (item: News) => {
          if (item.provingGround.length !== 0) {
            const provingGroundTitles = item.provingGround.map(
              (provingGr) => provingGr.title
            )
            return provingGroundTitles.toString()
          } else {
            return t('model.fileTemplate.allProvingGrounds')
          }
        },
      }),
      fieldColumn('description', {
        minWidth: 150,
        ungroupable: true,
      }),
      fieldColumn('created', {
        isSorted: true,
        isSortedDescending: true,
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('modified', {
        ungroupable: true,
        onRender: renderDate,
      }),
    ],
    [fieldColumn, t]
  )
  const renderRow = useCallback(
    (propsRow) => {
      const customStyles: Partial<IDetailsRowStyles> = {}
      if (propsRow && styledElementsCount > 0) {
        const indexFrom = items.length - styledElementsCount
        if (propsRow.itemIndex >= indexFrom) {
          customStyles.root = { backgroundColor: theme.palette.themeLighterAlt }
        }
      }
      return <DetailsRow {...propsRow} styles={customStyles} />
    },
    [styledElementsCount, items, theme.palette.themeLighterAlt]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      onRenderRow={renderRow}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
